import { z } from "zod";
import { type ParserType, parser } from "./parser";

export const SIZES = ["xs", "s", "m", "l", "xl"] as const;

export type Size = ParserType<typeof Size>;

export const Size = parser(z.enum(SIZES));
